import React, { useContext, useState, useEffect } from 'react';

import { usePermission } from '../../../../hooks/usePermission' 
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination';  
import PermissionDeleteModal from '../Delete/Delete';
import PermissionEditModal from '../Edit/Edit';
import AddPermissionModal from '../Add/Add';
import tbl from '../../../../assets/Style/Table.module.css'
import { useTranslation } from 'react-i18next';
import cl from './PermissionList.module.css'

const PermissionList = () => {
  const {t} = useTranslation();
  
  const { permissionService } = usePermission(50, true);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
    permissionService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    permissionService.setFilter({
      ...permissionService.filter,
      [name]: value
    });
  };


  const formatDate = (dateString) => {
      const createdAtDate = new Date(dateString);

      const months = [
          "იან",
          "თებ",
          "მარ",
          "აპრ",
          "მაი",
          "ივნ",
          "ივლ",
          "აგვ",
          "სექ",
          "ოქტ",
          "ნოე",
          "დეკ"
      ];

      const day = createdAtDate.getDate();
      const month = months[createdAtDate.getMonth()];
      const year = createdAtDate.getFullYear();
      const hours = createdAtDate.getHours().toString().padStart(2, '0'); // Pad with a zero if single-digit
      const minutes = createdAtDate.getMinutes().toString().padStart(2, '0'); // Pad with a zero if single-digit

      return `${day} ${month} ${year} ${hours}:${minutes}`; 
  };

  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Permissions')}</h1>  
        <AddPermissionModal  permissionService={permissionService}  /> 
    </div>
  
      
    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
                  <th className={cl.id} >#</th>
                  <th>{t('Name')}</th>
                  <th>{t('Description')}</th> 
              </tr>
          </thead>
          <tbody>
            {permissionService.items.map((permission) =>
                <tr key={permission.id} >
                  <td className={cl.id} >{permission.id} </td>
                  <td>{permission.name}</td>
                  <td>{permission.description}</td> 
                 
                </tr>  
              )}
          </tbody>
      </table>
 
      </div>



   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination 
      total={permissionService.total} 
        perPage={permissionService.filter.limit} 
        current={permissionService.filter.page} 
        paginate={(page) => {
            permissionService.setFilter({
            ...permissionService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
            permissionService.setFilter({
            ...permissionService.filter,
            limit: limit,
          });
        }}
    />
  </div>;
}

export default PermissionList;